/**
 * Layout intermedio del entorno RECIBIDAS. Añade una subnavegación en pestañas
 * ("Desde PDF" | "Desde Excel") sobre las pantallas hijas. Cada hija sigue
 * manteniendo su propia cabecera y layout completo.
 *
 * "Desde Excel" está disponible para todos los usuarios autenticados.
 */
import { NavLink, Outlet } from "react-router-dom";
import { FileStack, FileSpreadsheet } from "lucide-react";
import { cn } from "@/lib/utils";
import BackButton from "@/components/BackButton";

const tabClass = ({ isActive }: { isActive: boolean }) =>
  cn(
    "inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-md transition-colors border",
    isActive
      ? "bg-primary text-primary-foreground border-primary"
      : "bg-background text-muted-foreground border-transparent hover:bg-muted hover:text-foreground",
  );

const RecibidasLayout = () => {
  return (
    <div className="flex flex-col min-h-[calc(100vh-2.25rem)]">
      <nav className="border-b bg-muted/30 px-4 py-2 flex items-center gap-2">
        <BackButton variant="ghost" className="text-xs" />
        <span className="text-[10px] uppercase tracking-wider text-muted-foreground mr-2">
          Recibidas
        </span>
        <NavLink to="/app/pdf" className={tabClass}>
          <FileStack className="h-3.5 w-3.5" />
          Desde PDF
        </NavLink>
        <NavLink to="/app/excel" className={tabClass}>
          <FileSpreadsheet className="h-3.5 w-3.5" />
          Desde Excel
        </NavLink>
      </nav>
      <div className="flex-1 min-w-0">
        <Outlet />
      </div>
    </div>
  );
};

export default RecibidasLayout;
